module.exports = __webpack_public_path__ + "img/9788970174112.236e10cd.jpg";